import {
  ACCTRANS_LOADING,
  GET_ACCTRANS,
  GET_ACCTRANS_ONE,
  GET_ACCTRANS_SUCCESS,
  GET_ACCTRANS_FAIL,
  ADD_NEW_ACCTRANS,
  ADD_ACCTRANS_SUCCESS,
  ADD_ACCTRANS_FAIL,
  DELETE_ACCTRANS_SUCCESS,
  DELETE_ACCTRANS_FAIL,
  UPDATE_ACCTRANS_SUCCESS,
  UPDATE_ACCTRANS_FAIL,
  ACCTRANS_RESET
} from "./actionType";

const INIT_STATE = {
  accTranss: [],
  accTransOne: {},
  error: {},
};

const accTrans = (state = INIT_STATE, action) => {

  switch (action.type) {
    case GET_ACCTRANS_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ACCTRANS:
          return {
            ...state,
            accTranss: action.payload.data,
            isAccTransCreated: false,
            isAccTransSuccess: true,
            loading: false,
          };

        case GET_ACCTRANS_ONE:
          return {
            ...state,
            accTransOne: action.payload.data,
            isAccTransCreated: false,
            isAccTransSuccess: true,
            loading: false,
          };


        default:
          return { ...state };
      }
    case GET_ACCTRANS_FAIL:
      switch (action.payload.actionType) {
        case GET_ACCTRANS_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isAccTransCreated: false,
            isAccTransSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_ACCTRANS: {
      return {
        ...state,
        isAccTransCreated: false,
        loading: true,
      };
    }

    case GET_ACCTRANS_ONE: {
      return {
        ...state,
        accTransOne: action.payload.data,
        isAccTransCreated: false,
        loading: true,
      };
    }

    case ACCTRANS_LOADING: {
      return {
        ...state,
        isAccTransCreated: false,
        loading: true,
      };
    }

    case ADD_ACCTRANS_SUCCESS:
      return {
        ...state,
        isAccTransCreated: true,
        loading: false,
        accTranss: [action.payload.data, ...state.accTranss],
      };

    case ADD_ACCTRANS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_ACCTRANS_SUCCESS:
      return {
        ...state,
        loading: false,
        isAccTransCreated: true,
        accTranss: state.accTranss.filter(
          accTrans => accTrans.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_ACCTRANS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ACCTRANS_SUCCESS:
      return {
        ...state,
        loading: false,
        accTranss: state.accTranss.map(accTrans =>
          accTrans.id.toString() === action.payload.data.id.toString() ? { ...accTrans, ...action.payload.data } : accTrans
        ),
      };

    case UPDATE_ACCTRANS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACCTRANS_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default accTrans;